<template>
  <div>

      <v-card elevation="0">
        <v-form v-model="valid" ref="form">
          <v-toolbar color="orange lighten-4" dense elevation="0">
            <v-toolbar-title class="font-weight-bold">Insentif</v-toolbar-title>
            <v-chip
                class="ma-2"
                color="warning"
                outlined
                x-small
                v-show="isItemModified"
            >
              <v-icon left> mdi-pencil </v-icon>
              modified
            </v-chip>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="save"
                :disabled="!valid || isItemModified === false"
                class="hidden-md-and-up"
              >
                Simpan
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-title class="text-uppercase grey--text">

          </v-card-title>

          <v-card-text>
            <v-row >
              <v-col cols="12" md="12" sm="12">
                <vue-editor
                    v-if="false"
                    v-model="itemModified.notes"
                />
                <quill-editor
                    v-model="itemModified.notes"
                    :options="{
                      placeholder: 'Tulis seperti halnya ms Word...',
                      theme: 'snow'
                    }"
                    ></quill-editor>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pb-10 pr-16">

            <v-spacer></v-spacer>

            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="save"
              :disabled="!valid || isItemModified === false"
              class="hidden-sm-and-down"
            >
              Simpan
            </v-btn>

          </v-card-actions>
        </v-form>
      </v-card>


  </div>
</template>
  
<script>

import {VueEditor} from "vue2-editor";
import FDinCarouselService from "@/services/apiservices/f-din-carousel-service";
import FDinCarousel from "@/models/f-din-carousel";

import {quillEditor} from "vue-quill-editor/src";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css"; // Tema Snow
import "quill/dist/quill.bubble.css"; // Tema Bubble (opsional)

export default {
  name: "StrukturBidang",
  components: {
    VueEditor,
    quillEditor
  },
  data() {
    return {
      //INSENTIF
      constDinCarouselTypeBean: 801,

      itemDefault: "",
      itemModified: "",
      validateNotEmpty: (value) => !!value || "must contain a value",

      valid: false,
    };
  },
  computed: {
    isItemModified() {
      const defaultItem = JSON.stringify(this.itemDefault);
      const modifiedItem = JSON.stringify(this.itemModified);
      return defaultItem !== modifiedItem;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  watch: {},
  methods: {

    save() {
      if (this.isItemModified === false) {
        //Close aja
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
        return;
      }
      if (this.$refs.form.validate()) {
          FDinCarouselService.updateFDinCarousel(this.itemModified).then(
            () => {
              this.itemDefault = Object.assign({}, this.itemModified);
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },

    initializeEditMode() {

      FDinCarouselService.getAllFDinCarouselByTypePublic(this.constDinCarouselTypeBean).then(
        (response) => {
          // this.itemDefault = Object.assign({}, response.data);
          // this.itemModified = response.data;
          const items = response.data;

          if (items.length===0) {
            this.fistCreateObject();
          } else {
            this.itemDefault = Object.assign({}, items[0]);
            this.itemModified = items[0];
          }

        },
        (error) => {
          console.log(error);
        }
      )
    },

    fistCreateObject() {
      const item = new FDinCarousel();
      item.fdivisionBean = this.currentUser.fdivisionBean
      item.fdinCarouselTypeBean = this.constDinCarouselTypeBean;

      // console.log(JSON.stringify(item));

      FDinCarouselService.createFDinCarousel(item).then(
        (response) => {
          // console.log(JSON.stringify(response.data));

          this.itemDefault = Object.assign({}, response.data);
          this.itemModified = response.data;
        },
        (error) => {
          console.log(error);
        }
      )

    },

  },
  mounted() {
    this.initializeEditMode()
  },
  created() {

  }
};
</script>
  
<style scoped>

</style>